import { Typography } from "@circle-react-shared/uikit/Typography";
import { useCircleV4 } from "@circle-react/hooks/useCircleV4";
import { Banner } from "@circleco/compass/components/Banner";

import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";
import { planSettingsPath } from "@/react/helpers/urlHelpers";

export const CancellationBanner = () => {
  const { isCircleV4 } = useCircleV4();

  const handleRenewClick = () => {
    window.location.href = planSettingsPath();
  };

  if (isCircleV4) {
    return (
      <Banner
        variant="destructive"
        icon="triangle-exclamation"
        iconColor="danger"
        title={t("trial_banner.to_access_community")}
        description={t("trial_banner.to_access_community_description")}
        actionProps={{
          variant: "primary",
          children: t("trial_banner.renew_plan"),
          onClick: handleRenewClick,
        }}
      />
    );
  }

  return (
    <div>
      <div className="flex items-center gap-2 text-badge">
        <Typography.BodySm weight="font-normal" color="text-badge">
          {t("trial_banner.to_access_community")}
        </Typography.BodySm>
        <Button
          className="text-md font-semibold"
          variant="secondary"
          onClick={handleRenewClick}
        >
          {t("trial_banner.renew_subscription")}
        </Button>
      </div>
    </div>
  );
};
